export const tenantService = {
  async checkTenantExists(tenantId: string): Promise<boolean> {
    const normalizedTenantId = tenantId.trim().toLowerCase();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tenants/${encodeURIComponent(normalizedTenantId)}/exists`);
    if (!response.ok) {
      throw new Error('Failed to check tenant existence');
    }
    const result = await response.json();
    return result.exists;
  }
}; 